export default __webpack_public_path__ + "static/media/Mystic's Harness of the Crumbling Tower.27fcf4f8.jpg";